import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

import { RouteSegment } from '@core/enums/route-segment.enum';

import { AtAGlanceSiteCardComponent } from '@shared/components/at-a-glance-site-card';
import { AtAGlanceSiteCardLoadingSkeletonComponent } from '@shared/components/at-a-glance-site-card-loading-skeleton';
import { MovablePanelTitleComponent } from '@shared/components/movable-panel-title';
import { MoveablePanelComponent } from '@shared/components/moveable-panel/moveable-panel.component';
import { PanelLinkComponent } from '@shared/components/panel-link/panel-link.component';

import { SiteFleetsOverviewMovablePanelViewModel } from './site-fleets-overview-movable-panel.view-model';

@Component({
  selector: 'app-site-fleets-overview-movable-panel',
  imports: [
    MoveablePanelComponent,
    MovablePanelTitleComponent,
    AtAGlanceSiteCardComponent,
    AtAGlanceSiteCardLoadingSkeletonComponent,
    PanelLinkComponent,
    RouterLink,
    TranslatePipe,
  ],
  templateUrl: './site-fleets-overview-movable-panel.component.html',
  host: { class: 'flex flex-col' },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SiteFleetsOverviewMovablePanelComponent {
  public readonly vm = input<SiteFleetsOverviewMovablePanelViewModel>();
  public readonly isLoading = input<boolean>(false);

  protected readonly RouteSegment = RouteSegment;
  protected readonly skeletonRows = Array.from({ length: 3 });
}
